import { useState } from 'react';

import { IconClose } from '../../../common/icons';
import { useModalDialog } from '../../../common/hooks/use-modal-dialog';
import { CL_QUALITIES, TE_MEDICATIONS, TE_STATES } from '../../../core/constants/transfers';

// Popovers clínicos por transferencia (estilo v1), guardados en remarks JSON:
//   remarks.corpusLuteum = { corpusLuteum:{left,right}, quality, cavernous }
//   remarks.details      = { state, medication, observations }
// Se renderizan como overlay centrado.

function Overlay({ title, children, onClose }) {
    const cardRef = useModalDialog(onClose);
    return (
        <div className="transfer-pop" role="dialog" aria-modal="true" aria-label={title}>
            <div className="transfer-pop__overlay" onClick={onClose} aria-hidden="true" />
            <div className="transfer-pop__card" ref={cardRef}>
                <header className="transfer-pop__head">
                    <h2 className="transfer-pop__title">{title}</h2>
                    <button type="button" className="transfer-pop__close" onClick={onClose} aria-label="Cerrar"><IconClose /></button>
                </header>
                {children}
            </div>
        </div>
    );
}

export function CorpusLuteumPopover({ index, value, onApply, onClose }) {
    const [side, setSide] = useState(value?.corpusLuteum ?? { left: true, right: false });
    const [quality, setQuality] = useState(value?.quality ?? null);
    const [cavernous, setCavernous] = useState(value?.cavernous ?? false);

    const pickQuality = (q) => {
        const next = quality === q ? null : q; // tocar la activa la deselecciona
        setQuality(next);
        if (next !== 1 && next !== 2) setCavernous(false);
    };

    const save = () => { onApply({ corpusLuteum: side, quality, cavernous }); onClose(); };

    return (
        <Overlay title={`Cuerpo lúteo · E-${index}`} onClose={onClose}>
            <div className="transfer-pop__section">
                <span className="transfer-pop__label">Lado</span>
                <div className="transfer-pop__seg">
                    <button type="button" className={`transfer-pop__seg-btn ${side.left ? 'transfer-pop__seg-btn--active' : ''}`} onClick={() => setSide({ left: true, right: false })}>Izquierdo</button>
                    <button type="button" className={`transfer-pop__seg-btn ${side.right ? 'transfer-pop__seg-btn--active' : ''}`} onClick={() => setSide({ left: false, right: true })}>Derecho</button>
                </div>
            </div>

            <div className="transfer-pop__section">
                <span className="transfer-pop__label">Calidad (opcional)</span>
                <div className="transfer-pop__quality">
                    {CL_QUALITIES.map((q) => (
                        <div key={q} className="transfer-pop__q-item">
                            <button type="button" className={`transfer-pop__q-btn ${quality === q ? 'transfer-pop__q-btn--active' : ''}`} onClick={() => pickQuality(q)}>{q}</button>
                            {(q === 1 || q === 2) && quality === q && (
                                <button type="button" className={`transfer-pop__cav ${cavernous ? 'transfer-pop__cav--active' : ''}`} onClick={() => setCavernous((p) => !p)}>cav</button>
                            )}
                        </div>
                    ))}
                </div>
            </div>

            <div className="transfer-pop__actions">
                <button type="button" className="transfer-pop__cancel" onClick={onClose}>Cancelar</button>
                <button type="button" className="transfer-pop__save" onClick={save}>Guardar</button>
            </div>
        </Overlay>
    );
}

export function ObservationsPopover({ index, value, onApply, onClose }) {
    const [state, setState] = useState(value?.state ?? 'VP');
    const [medication, setMedication] = useState(value?.medication ?? '');
    const [observations, setObservations] = useState(value?.observations ?? '');

    const save = () => { onApply({ state, medication, observations }); onClose(); };

    return (
        <Overlay title={`Observaciones · E-${index}`} onClose={onClose}>
            <div className="transfer-pop__section">
                <span className="transfer-pop__label">Estado actual</span>
                <div className="transfer-pop__seg">
                    {TE_STATES.map((s) => (
                        <button key={s.value} type="button" className={`transfer-pop__seg-btn ${state === s.value ? 'transfer-pop__seg-btn--active' : ''}`} onClick={() => setState(s.value)}>{s.label}</button>
                    ))}
                </div>
            </div>

            <div className="transfer-pop__section">
                <span className="transfer-pop__label">Medicación</span>
                <select className="transfer-pop__select" value={medication} onChange={(e) => setMedication(e.target.value)}>
                    {TE_MEDICATIONS.map((m) => <option key={m.value} value={m.value}>{m.label}</option>)}
                </select>
            </div>

            <div className="transfer-pop__section">
                <span className="transfer-pop__label">Observaciones</span>
                <textarea className="transfer-pop__textarea" value={observations} onChange={(e) => setObservations(e.target.value)} rows={3} placeholder="Observaciones clínicas" />
            </div>

            <div className="transfer-pop__actions">
                <button type="button" className="transfer-pop__cancel" onClick={onClose}>Cancelar</button>
                <button type="button" className="transfer-pop__save" onClick={save}>Guardar</button>
            </div>
        </Overlay>
    );
}
